'use client'

import { cn } from '@src/utils/tailwind'

interface PillProps {
  label: string
  isActive: boolean
}

export function Pill({ label, isActive }: PillProps) {
  return (
    <button
      className={cn(
        'box-border block rounded-[40px] border border-bodi-gray-light bg-bodi-white px-4 py-3 font-medium hover:bg-bodi-gray-pearl lg:px-6',
        isActive &&
          'border-transparent bg-bodi-black font-semibold text-bodi-green-bright-500 hover:bg-bodi-black'
      )}
    >
      {label}
    </button>
  )
}
